module.exports = __webpack_public_path__ + "img/10step-02-04-1-1_ergebnis.0c321040.webp";